<p-toast></p-toast>

<app-data-table [title]="title" [columns]="tableColumns" [filters]="tableFilters" [items]="items" [totalCount]="count"
    [page]="page" [pageSize]="pageSize" [loading]="loading" [filterValues]="tableFilterValues" createLabel="Aggiungi"
    [createLink]="['/admin/news/create']" [editLink]="editLink" [rowActions]="rowActions"
    (pageChange)="handlePageChange($event)" (search)="onTableSearch($event)" (delete)="onDelete($event)"
    (action)="onAction($event)">
</app-data-table>

{{ error }}